// src/components/ReadjudicacionMasiva/Auditoria/ExpedienteSelector.js

import React, { useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
    TextField,
    CircularProgress,
    Typography,
    Box
} from '@mui/material';
import { Autocomplete } from '@mui/material';
import useReadjudicacion from '../../../hooks/useReadjudicacion';

const useStyles = makeStyles((theme) => ({
    autocomplete: {
        width: '100%'
    }
}));

const ExpedienteSelector = ({ value, onChange, disabled }) => {
    const classes = useStyles();
    const { buscarExpedientesAdm } = useReadjudicacion();

    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');

    const handleInputChange = async (event, newInputValue, reason) => {
        // Solo actualizar inputValue si el usuario está escribiendo (no cuando se selecciona)
        if (reason === 'input') {
            setInputValue(newInputValue);

            if (newInputValue.length >= 2) {
                setLoading(true);
                try {
                    const expedientes = await buscarExpedientesAdm(newInputValue);
                    setOptions(expedientes);
                } catch (error) {
                    console.error('Error al buscar expedientes:', error);
                    setOptions([]);
                }  finally {
                    setLoading(false);
                }
            } else {
                setOptions([]);
            }
        } else if (reason === 'clear') {
            setInputValue('');
            setOptions([]);
        }
    };

    const handleChange = (event, newValue) => {
        onChange(newValue);
        // Actualizar el inputValue con el formato completo cuando se selecciona
        if (newValue) {
            const descripcion = newValue.Extracto || newValue.Caratula || '';
            setInputValue(`${newValue.Expediente || ''} - ${descripcion}`);
        } else {
            setInputValue('');
        }
    };

    return (
        <Autocomplete
            className={classes.autocomplete}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            value={value}
            onChange={handleChange}
            inputValue={inputValue}
            onInputChange={handleInputChange}
            options={options}
            isOptionEqualToValue={(option, value) => option.Id === value?.Id}
            getOptionLabel={(option) => {
                if (typeof option === 'string') return option;
                const descripcion = option.Extracto || option.Caratula || '';
                return `${option.Expediente || ''} - ${descripcion}`;
            }}
            loading={loading}
            disabled={disabled}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Expediente Administrativo"
                    variant="outlined"
                    size="small"
                    placeholder="Buscar por número o carátula"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                />
            )}
            noOptionsText="Ingrese al menos 2 caracteres para buscar"
            renderOption={(props, option) => (
                <li {...props} key={option.Id}>
                    <Box>
                        <Typography variant="body2" style={{ fontWeight: 600 }}>
                            {option.Expediente || 'Sin número'}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {option.Extracto || option.Caratula || 'Sin extracto'}
                        </Typography>
                    </Box>
                </li>
            )}
        />
    );
};

export default ExpedienteSelector;
